import request from './request';

const messageSubscriberService = {
  getAll: (params) =>
    request.get('dashboard/admin/message-subscribers/all', { params }),
  export: () =>
    request.get('dashboard/admin/message-subscribers/export'),
  deleteOne: (id) =>
    request.delete(`dashboard/admin/message-subscribers/${id}`),
  deleteBulk: (ids) =>
    request.delete('dashboard/admin/message-subscribers/delete', { data: { ids } }),
};

export default messageSubscriberService;
